module.exports = __webpack_public_path__ + "img/38243979.8b90728b.png";